export const getDashboardObj = (dashboards, projectsOverviewTable, item) => {
  if (projectsOverviewTable.headers[0].toLowerCase().includes("project")) {
    const title = item[0];
    return dashboards.find((d) => d.title === title);
  }
};
